module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_8011.2fc25b53.png";